module.exports = __webpack_public_path__ + "static/media/Logo-GEO.e379e1c6.JPG";